/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLineCuteFi: {
  name: 'line-cute-fi';
  data: string;
} = {
  name: 'line-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.516 2.577a2.31 2.31 0 0 0-.32.163c-.097.059-3.831 3.765-8.299 8.234C1.693 20.182 2.54 19.267 2.54 20c0 .385.01.439.117.651.139.273.445.575.723.711.174.085.255.098.62.098.733 0-.187.853 9.063-8.397S21.46 4.733 21.46 4c0-.365-.013-.446-.098-.62a1.793 1.793 0 0 0-.711-.723c-.201-.102-.281-.118-.611-.126-.246-.006-.431.01-.524.046"/></svg>`
};
